export default __webpack_public_path__ + "static/media/daredevil2.ac94fd08.jpg";